import { defineStyleConfig } from '@chakra-ui/react';
import type { TextProps } from '@chakra-ui/react';

const baseTheme = defineStyleConfig({
    baseStyle: {
        textStyle: 'slt-body-text',
    },
});

type ThemeStyleConfig = ReturnType<typeof defineStyleConfig>;
type TextTheme = ThemeStyleConfig & {
    defaultProps: ThemeStyleConfig['defaultProps'] & Pick<TextProps, 'color'>;
};

export const Text: TextTheme = {
    ...baseTheme,
    defaultProps: {
        ...baseTheme.defaultProps,
        color: 'slt-black.900',
    },
};
